import { Button } from 'antd';
import landing from 'assets/img/landing.svg';
import styles from './NoDeveloperTag.module.less';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { resendVerificationEmail } from 'redux/reducers/authenticationSlice';
import { CheckCircleOutlined } from '@ant-design/icons';
import OmniNotification from 'components/OmniNotification';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isAdminSelector, userSelector, userTagsSelector } from 'redux/selectors/userSelector';
export default function NoDeveloperTag() {
	const { logout, user } = useAuth0();
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const { t } = useTranslation();
	const userTags = useSelector(userTagsSelector);

	const resendVerificationEmailAction = async () => {
		setIsLoading(true);
		const resendResult = await dispatch(resendVerificationEmail());
		//@ts-ignore
		if (resendVerificationEmail.fulfilled.match(resendResult)) {
			setIsLoading(false);
			OmniNotification.success({
				message: t('EmailVerificationPage.ResendSuccess'),
			});
		}
	};
	return (
		<>
			{userTags !== null && userTags.includes('developer') && <Redirect to="/projects" />}

			<div className={styles.emailVerification}>
				<div className={styles.emailVerificationLogo}>
					<img src={landing} alt="logo" />
				</div>
				<div className={styles.emailVerificationWrapper}>
					<div className={styles.emailVerificationContent}>
						<p
							style={{
								textAlign: 'center',
								fontSize: '30px',
								fontWeight: 'bold',
							}}
						>
							Contact your Virtuix representative to get access.
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
